import { Box, Button, Text } from '@factorialco/deprecated-design-system'

interface Props {
  onSync: () => void
  syncing: boolean
  title: string
  description: string
  submitButton: string
}

const Available = ({ onSync, syncing, title, description, submitButton }: Props) => {
  return (
    <>
      <Text.Header2>{title}</Text.Header2>
      <Box>{description}</Box>
      <Button onClick={onSync} disabled={syncing}>
        {submitButton}
      </Button>
    </>
  )
}

export default Available
